import { memo, useEffect } from 'react';
import memoize from 'transmute/memoize';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { DATAWELL } from '../../constants/visualizationTypes';
import Datawell from './components/Datawell';
import { mapDatawellToViz } from './datawellMapper';
import { DatawellVisualization } from './datawellRecords';
import { jsx as _jsx } from "react/jsx-runtime";
const mapDatawell = memoize(mapDatawellToViz);
export const type = DATAWELL;
export const record = DatawellVisualization;
const DatawellViz = ({
  visualization,
  debug = DEFAULT_DEBUG,
  onReportVisualize
}) => {
  const datawell = mapDatawell(visualization);
  useEffect(() => {
    debug.set('Datawell', datawell);
  }, [datawell, debug]);
  const datawellComponent = /*#__PURE__*/_jsx(Datawell, {
    datawell: datawell,
    onReportVisualize: onReportVisualize
  });
  return datawellComponent;
};
export const Render = /*#__PURE__*/memo(DatawellViz);